module.exports = __webpack_public_path__ + "static/media/doctor2-300.3fe3190a.webp";